import { useEffect, useRef, useState } from 'react';

const useWebSocket = (protocols) => {
  const webSocketRef = useRef(null);
  const retryTimeoutRef = useRef(null);
  const shouldReconnectRef = useRef(true);
  const [websocket, setWebsocket] = useState(null);

  const protocol = 'wss';
  const host = window.location.hostname;
  const isProd = process.env.NODE_ENV === 'production';
  const port = isProd ? '' : '3001';
  const wsUrl = isProd ? `${protocol}://${host}/api/frontend` : `${protocol}://${host}:${port}/api/frontend`;

  useEffect(() => {
    shouldReconnectRef.current = true;
    let isActive = true;

    function scheduleReconnect() {
      if (!isActive || !shouldReconnectRef.current) {
        return;
      }
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
      retryTimeoutRef.current = setTimeout(connect, 5000); // Retry every 5 seconds
    }

    function connect() {
      if (!isActive || !shouldReconnectRef.current) {
        return;
      }
      const ws = new WebSocket(wsUrl, protocols);
      webSocketRef.current = ws;
      setWebsocket(ws);

      ws.onopen = () => {
        console.log('WebSocket connection opened');
      };

      ws.onmessage = (message) => {
        console.log('WebSocket message received:', message.data);
      };

      ws.onclose = () => {
        console.log('WebSocket connection closed');
        if (webSocketRef.current === ws) {
          webSocketRef.current = null;
        }
        if (isActive) {
          setWebsocket(null);
        }
        scheduleReconnect();
      };

      ws.onerror = (error) => {
        console.error('WebSocket error:', error);
        scheduleReconnect();
      };
    }

    connect();

    return () => {
      isActive = false;
      shouldReconnectRef.current = false;
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
      if (webSocketRef.current) {
        webSocketRef.current.close();
      }
    };
  }, [protocols, wsUrl]);

  return websocket;
};

export default useWebSocket;
